import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

export const ComponentCard = ({
  title,
  description,
  children,
  className,
}: {
  title?: string | null;
  description?: string | null;
  children: ReactNode;
  className?: string;
}) => (
  <Card className={cn("gap-4 overflow-hidden", className)}>
    {(title || description) && (
      <CardHeader className="gap-2">
        {title ? <CardTitle className="text-base">{title}</CardTitle> : null}
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
    )}
    <CardContent className="px-4 pb-4 sm:px-6">{children}</CardContent>
  </Card>
);

export const ChartCard = ({
  title,
  description,
  children,
}: {
  title?: string | null;
  description?: string | null;
  children: ReactNode;
}) => (
  <Card className="gap-4 overflow-hidden">
    {title || description ? (
      <CardHeader className="gap-2">
        {title ? <CardTitle className="text-base">{title}</CardTitle> : null}
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
    ) : null}
    <CardContent className="px-4 pb-4 sm:px-6">{children}</CardContent>
  </Card>
);
